/** Kontakt klubu – jedno místo pro všechny obrazovky (O aplikaci, GDPR, chybové stavy). */
export const CONTACT_EMAIL = "czhrsa@seznam.cz";
